import { Flex } from 'components/Flex/Flex';
import { LoaderMask } from 'components/LoaderMask/LoaderMask';
import { useAsyncEffect } from 'customHooks/hooks';
import React, { ReactElement, useContext } from 'react';
import { WidgetGeneratorContext } from 'screens/WidgetGenerator/contexts/WidgetGeneratorContext';
import { getOverallScoreData } from 'screens/WidgetGenerator/helpers/overallScore';
import { OverallSatisfactionData } from 'screens/WidgetGenerator/utils/misc';
import { OverallBarChart } from 'screens/WidgetGenerator/widgets/BarChart/OverallBarChart/OverallBarChart';
import { logger } from 'utils/logger';

const DEFAULT_OVERALL_SCORE_DATA: OverallSatisfactionData = {
  score: {
    positive: 0,
    neutral: 0,
    negative: 0,
  },
  totalSubmissions: 0,
};

export const OverallSatisfactionCharttHOC = (): ReactElement => {
  const { client, cycles, selectedDateRange } = useContext(WidgetGeneratorContext);

  const fetchOverallScoreData = async () => {
    const fetchedOverallScoreData = await getOverallScoreData(client, cycles, selectedDateRange);
    return fetchedOverallScoreData;
  };

  const {
    fetchedData: overallScoreData,
    isLoading,
    error,
  } = useAsyncEffect(fetchOverallScoreData, [client, cycles, selectedDateRange]);

  if (error) {
    logger.error(error);
  }
  const isBenchmarked = Boolean(overallScoreData?.previousCycle?.totalSubmissions);

  return (
    <LoaderMask isLoading={isLoading}>
      <Flex justifyContent="flex-end">
        <OverallBarChart
          widgetData={overallScoreData ?? DEFAULT_OVERALL_SCORE_DATA}
          isBenchmarked={isBenchmarked}
          isLabeled
        />
      </Flex>
    </LoaderMask>
  );
};
